<template>
    <slot></slot>
</template>

<script lang="ts" setup>
import { useAffirmRefresh } from '@/third-party/affirm.ts'

const props = defineProps<{
    refreshKey: string | number | null
}>()

useAffirmRefresh(() => props.refreshKey)
</script>
